import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileDownload } from '@fortawesome/free-solid-svg-icons';
import "./Confirmation.css";
import { PDFDownloadLink } from "@react-pdf/renderer";
import {DownloadPDF as PDFDoc} from './DownloadPDF';
import { createRoot } from 'react-dom/client';
import {
  resetPersonalInfoData,
  restExamDetails,
  restInstitutionDetails,
  resetStateTransitionFlags,
  getExamSeriesError,
  getInstitutionsError
} from '../../redux-building-blocks/actions';
import { constants } from "../../constants";
import moment from 'moment';
const faFileDownloadV5 = {
    prefix: 'fas',
    iconName: 'file-download',
    icon: [
        384, 512, [], 'f56d',
        'M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z'
    ]
};
 
export class Confirmation extends React.Component {
  constructor(props){
    super(props);
    this.state={};
    this.isComponentMounted = false;
    this.activeDownloadRequestId = 0;
    this.pendingDownloadTimeout = null;
    this.downloadHostElem = null;
    this.downloadRoot = null;
  }
  componentDidMount(){
    this.isComponentMounted = true;
    const orderData = localStorage.getItem('transcript');
    if(orderData){
      var transcriptData = JSON.parse(orderData);
      this.setState({transcriptData,loading:false});
      localStorage.removeItem('transcript');
    }else{
      this.props.history.push('/transcript-history');
    }
  }
  componentWillUnmount(){
    this.isComponentMounted = false;
    this.clearDownloadArtifacts();
  }
  clearDownloadArtifacts = () => {
    if (this.pendingDownloadTimeout) {
      clearTimeout(this.pendingDownloadTimeout);
      this.pendingDownloadTimeout = null;
    }
    if (this.downloadRoot) {
      this.downloadRoot.unmount();
      this.downloadRoot = null;
    }
    if (this.downloadHostElem && this.downloadHostElem.parentNode) {
      this.downloadHostElem.parentNode.removeChild(this.downloadHostElem);
    }
    this.downloadHostElem = null;
  }
  navToTranscriptHistory = () => {
    if (this.props.stateNavFlags.isHistoryPayNav) {
      this.props.getExamSeriesError();
      this.props.getInstitutionsError();
    }
    this.props.resetPersonalInfoData();
    this.props.restExamDetails();
    this.props.restInstitutionDetails();
    this.props.resetStateTransitionFlags();
    this.props.history.push('/transcript-history');
  }
  buildPDF = () => {
    const { loading,transcriptData } = this.state;
    if (!loading) {
      this.activeDownloadRequestId += 1;
      const requestId = this.activeDownloadRequestId;
      this.clearDownloadArtifacts();
      this.setState({ loading: true }, 
                    () => {
                      this.downloadPDF(this.PdfDocument(),
                                       transcriptData.orderNumber,
                                      `file`,
                                      requestId,
                                      () => {
                                        if (this.isComponentMounted && requestId === this.activeDownloadRequestId) {
                                          this.setState({ loading: false });
                                        }
                                      });
                    });
    }
  };
  
  PdfDocument = () => { return (<PDFDoc props={this.state.transcriptData}/>); }
  
  downloadPDF = (pdfContent, filename, divId, requestId, callback) => {
    this.pendingDownloadTimeout = setTimeout(() => {
      const link = (
        <div id={divId}>
          <PDFDownloadLink document={pdfContent} fileName={filename}>
            {({ blob, url, loading, error }) => {
              if (!loading && (blob && blob instanceof Blob) && this.isComponentMounted && requestId === this.activeDownloadRequestId) {
                const objectUrl = URL.createObjectURL(blob);
                this.download(filename, objectUrl);
                URL.revokeObjectURL(objectUrl);
                callback();
                this.clearDownloadArtifacts();
              }
            }}
          </PDFDownloadLink>
        </div>
      );
      const parentElem = document.getElementById('pdfButton');
      if (!parentElem || !this.isComponentMounted || requestId !== this.activeDownloadRequestId) {
        return;
      }
      const elem = document.createElement('div');
      parentElem.appendChild(elem);
      this.downloadHostElem = elem;
      this.downloadRoot = createRoot(elem);
      this.downloadRoot.render(link);
      this.pendingDownloadTimeout = null;
    }, 50);
  };
  download = (filename, url) => {
    const element = document.createElement('a');
    element.setAttribute('href', `${url}`);
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element)
    element.click();
    document.body.removeChild(element);
  };
  render() {    
    const {transcriptData} = this.state,{accepted,pendingOrReceived} = constants.confirmation,
          status = transcriptData?.status?.toLowerCase(),
          payAccepted = status === "authorised" || status === "authorisedpending",
          underProcess = status === "pending" || status === "received",
          headerMsg = payAccepted ? accepted : underProcess ? pendingOrReceived : "";    
    if(transcriptData){                  
      return (    
        <React.Fragment>      
          <div className="w-100">
              {headerMsg.msg1 && headerMsg.msg1.split('\n').map(i=>{return <p className="font-weight-bold h4 mb-3 mt-3">{i}</p>})}
              <p className="mb-0 sectionLabel">{headerMsg.msg2}</p>
              <p className="sectionLabel">{headerMsg.msg3}</p>
                <div className="card mt-2">
                    <div className="card-body">
                          <div className="mb-2">
                                  <div className="sectionLabel mb-3">
                                      <p className="mb-3"><span className="font-weight-bold">Order number: </span>{transcriptData.orderNumber}</p>
                                      <p className="mb-0"><span className="font-weight-bold">Payment received: </span>{transcriptData.date && moment(transcriptData.date).format('DD MMMM yyyy')}</p>
                                  </div>
                                  <div className="sectionLabel">
                                      <p><span className="font-weight-bold">Student name: </span>{transcriptData.name}</p>
                                      <p><span className="font-weight-bold">Email: </span>{transcriptData.email}</p>
                                  </div>
                          </div>
                          <div className='pl-3 row mb-3'>
                            <div className="sectionLabel font-weight-bold">Exam(s):</div>
                              <div className='ml-minus-5 col-10'>                      
                                {transcriptData.directToPay? transcriptData.exams.map((item,index) => {
                                  return(<div key={index} className="sectionLabel mb-3">
                                            <p className="mb-0">{item.session}</p>
                                            <p className="mb-0">{constants.EXAM_DETAILS.EXAM_NAME}</p>
                                            <p className="mb-0">{item.centreName}</p>
                                        </div>)}):                    
                                transcriptData.exams.map((item,index) => {
                                  return(<div key={index} className="sectionLabel mb-3">
                                            <p className="mb-0">{item?.examSeries.month}  {item?.examSeries.year}</p>
                                            <p className="mb-0">{item.exam}</p>
                                            <p className="mb-0">{item.examCenter}</p>
                                        </div>) 
                                })}
                              </div>
                          </div>
                          <div className='pl-3 row'>
                                <div className="sectionLabel font-weight-bold">Institutions:</div>
                                  <div className='ml-minus-5 col-10'>
                                    {transcriptData.directToPay? transcriptData.institutions.map((item,i) => {
                                      return(<div key={i} className="sectionLabel mb-2"><p className="mb-0">{item.split(',')[0]}</p></div>)                                         
                                    }):                                  
                                    transcriptData.institutions.map(item => {
                                      return(<div key={item.id} className="sectionLabel mb-3">
                                                <p className="mb-0">{item.institute.split(',')[0]}</p>
                                                <p className="mb-0">{item.StreetRoadName}</p>
                                                <p className="mb-0">{item.CityTownName}, {item.CountyRegionName} {item.PostCode}</p>
                                            </div>)                          
                                    })}
                                  </div>
                            </div> 
                          <div><span className="sectionLabel font-weight-bold mr-2">Fee: $</span>{transcriptData.fee}</div>
                          {payAccepted && <div><span className="sectionLabel font-weight-bold mr-2">Payment reference:</span>{transcriptData.payReferenceNumber}</div>}
                          {payAccepted && <p className="mt-4 sectionLabel">After payment is received, grade transcripts will be sent within 14 days.
                              If you include a future exam series in the request, transcripts will be sent within 14 days of the future results release day.
                              If you have a query about your application, contact Customer Services by emailing <a href="mailto:info@cambridgeinternational.org">info@cambridgeinternational.org</a> or call 917-810-2660 (toll free, open 24 hours).
                            </p>}
                      </div>
                </div>
                {payAccepted && 
                <>
                  <div id="pdfButton"></div> 
                  <div className="mt-2 mb-4 pl-2 font-weight-bold">
                          <span><FontAwesomeIcon icon={faFileDownloadV5}/></span>
                          <span><button id="downloadPDF" style={{textDecoration: "none",padding: "10px",
                                                color: " #000000",border: "none",
                                                fontWeight:"bold"}} 
                                        onClick={() => this.buildPDF()}>Download PDF</button></span>
                  </div>
                </>}
              
          <div className="mt-3 mb-3">
                <button onClick={this.navToTranscriptHistory} 
                type="button" id="redirectButton" className="btn font-weight-bold save-button-confirmation text-white pl-2 pr-2">Return to account</button> 
          </div>
          </div>       
        </React.Fragment>
      );
    }
  }
}const mapStateToProps = state => {
  return {
    PersonalInfoFromSAPCDC : state.currentUser.profile,
    transactionId: state.commonData.transactionId,
    PersonalInfoLocal : state.personalInfo,
    examDetailsList : state.examDetailsInfo.examDetailsList,
    institutionDetailsList : state.institutesDetailsInfo.institutesDetailList,
    confirmationInfo : state.ConfirmationInfo,
    stateNavFlags: state.stateTransition
  };
};
const mapDispachToProps =  {
  resetPersonalInfoData,
  restExamDetails,
  restInstitutionDetails,
  resetStateTransitionFlags,
  getExamSeriesError,
  getInstitutionsError
};
export default withRouter(connect(
  mapStateToProps,mapDispachToProps
)(Confirmation));
